export default "<div id=\"id_recaptcha\"></div>\r\n";